import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { SopDataModel } from "../api/responsePayload/SopResponse";
import { getSopKnowledge, getSopId } from "../api/SopApiCall";
import { showConsoleError } from "../util/ConsoleMessage";
import { resetPagination, setPagination } from "./pagination.slice";

interface SopState {
  items: SopDataModel[];
  loading: boolean;
  error?: string;
}

const initialSopState: SopState = { items: [], loading: false };

export const fetchSopKnowledge = createAsyncThunk(
  "sop/fetch",
  async (
    args:
      | { endpoint?: string; page?: number; queryParams?: Record<string, any> }
      | undefined,
    { dispatch, rejectWithValue }
  ) => {
    try {
      const res = await getSopKnowledge(
        args?.endpoint,
        {},
        args?.queryParams ?? {},
        args?.page
      );
      if (res) {
        dispatch(
          setPagination({
            currentPage: res.current_page,
            nextPageUrl: res.next,
            prevPageUrl: res.previous,
            totalPages: res.total_pages,
            totalCount: res.count,
          })
        );
        return res.results as SopDataModel[];
      }
      return [] as SopDataModel[];
    } catch (e: any) {
      showConsoleError("fetchSopKnowledge error", e);
      return rejectWithValue(String(e));
    }
  }
);

export const fetchSopById = createAsyncThunk(
  "sop/fetchById",
  async (id: number, { dispatch, rejectWithValue }) => {
    try {
      const res = await getSopId(id);
      dispatch(resetPagination());
      const item: SopDataModel | undefined =
        res && (res as any).data
          ? (res as any).data
          : (res as SopDataModel | undefined);

      return item ? [item] : [];
    } catch (e: any) {
      showConsoleError("fetchSopById error", e);
      return rejectWithValue(String(e));
    }
  }
);

export const sopSlice = createSlice({
  name: "sop",
  initialState: initialSopState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSopKnowledge.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchSopKnowledge.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchSopKnowledge.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchSopById.fulfilled, (state, action) => {
        state.items = action.payload;
      });
  },
});

export default sopSlice.reducer;
